import React, { createContext, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router';

export const LastLocationContext = createContext({});
LastLocationContext.displayName = 'LastLocationContext';

export default function LastLocationProvider({ children }) {
  const location = useLocation();
  const next = useRef();
  const last = useRef();
  const value = useMemo(
    function factory() {
      if (location.pathname !== next.current) {
        if (next.current) {
          last.current = next.current;
        }

        next.current = location.pathname;
      }

      return last.current;
    },
    [location.pathname],
  );

  return (
    <LastLocationContext.Provider value={value}>
      {children}
    </LastLocationContext.Provider>
  );
}

LastLocationProvider.propTypes = {
  children: PropTypes.node,
};
